import { pick, toNumber } from "@components/health/clients/health-clients-utils";

/** Вид диагноза (SPR_SERVIS.VID). */
export const VID_DIAGNOSIS = 41;

/** Вид записи в дневник (SPR_SERVIS.VID). */
export const VID_DIARY = 42;

export const VID_OPTIONS = [
  { value: VID_DIAGNOSIS, label: "Вид диагноза" },
  { value: VID_DIARY, label: "Вид записи в дневник" }
];

/** Вид CDA для VID=42 (Delphi MIOperControls_SprServiceId1). */
export const CDA_OPTIONS = [
  { value: 0, label: "" },
  { value: 1, label: "Консультация" },
  {
    value: 2,
    label: "Выписка из истории болезни амбулаторного больного"
  }
];

export const CDA_LABELS = Object.fromEntries(
  CDA_OPTIONS.filter((o) => o.value !== 0).map((o) => [o.value, o.label])
);

/** Как Delphi GetUserLaw: отсутствующий бит = разрешено. */
export const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

export const normalizeServis = (row) => ({
  vid: toNumber(pick(row, "vid", "Vid")),
  id: toNumber(pick(row, "id", "Id")),
  name: pick(row, "name", "Name") ?? "",
  isOk: toNumber(pick(row, "isOk", "IsOk")) ?? 0,
  id1: toNumber(pick(row, "id1", "Id1")) ?? 0,
  isHide: toNumber(pick(row, "isHide", "IsHide")) ?? 0
});
